import React, { useEffect, useState } from "react";
import { PremisesCleaningIcon } from "../../Icon/PremisesCleaningIcon";
import { getSprzatanie } from "../../helpers/Api";
import { BlueMarker, WhiteMarker } from "./MarkerIcon";
import { CardServices } from "../../../shared/card-services/CardServices";
import { CustomRadio } from "../../../shared/custom-radio/CustomRadio";

export function PremisesCleaning({ premisesCleaning, setPremisesCleaning, priceOne, setPriceOne, changeUslugiFirstBlock, setChangeUslugiFirstBlock }) {

  useEffect(() => {
    getSprzatanie().then((data) => {
      setPremisesCleaning(data);
    });
  }, [setPremisesCleaning]);

  const [showFirst, setShowFirst] = useState(true);
  const [showSecond, setShowSecond] = useState(false);

  const toggleShowShowFirst = () => {
    setShowFirst(!showFirst);
    setShowSecond(false);
    setChangeUslugiFirstBlock(0);
  };

  const toggleShowShowSecond = () => {
    setShowSecond(!showSecond);
    setShowFirst(false);
    setChangeUslugiFirstBlock(1);
  };

  useEffect(() => {
    if (priceOne === "") {
      setChangeUslugiFirstBlock(0);
      setShowFirst(true)
      setShowSecond(false);
    }
    // Set changeUslugiFirstBlock to 0 when the component mounts
    setChangeUslugiFirstBlock(0);
  }, [priceOne, setChangeUslugiFirstBlock]);

  const isInputEmpty = priceOne === '';

  return (
    <div className="__osobiste__block __block__yborka">
      <CardServices
        isInputEmpty={isInputEmpty}
        title='уборка помещений'
      >
        <PremisesCleaningIcon />
      </CardServices>
      <div className="__osobiste__block__right sprzątanie-wrapp">
        {premisesCleaning.map((option) => {
          if (option.id === 1) {
            return (
              <div key={option.id} className="sprzątanie-top">
                <span>{option.name}:</span>
                <div className="sprzątanie-top-input-wrapp">
                  <input type="number" min="20" step="1" max="2000"
                    value={priceOne}
                    onChange={event => {
                      setPriceOne(event.target.value);
                    }}

                    pattern="[1-9][0-9]*"
                    onKeyPress={(event) => {
                      if (event.key === '0' && event.target.value.length === 0) {
                        event.preventDefault();
                      }
                      // Блокируем ввод любых символов, кроме цифр
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}

                    onBlur={(event) => {
                      const inputValue = parseInt(event.target.value);

                      if ((inputValue >= 1 && inputValue <= 19)
                        // || isNaN(inputValue)
                      ) {
                        setPriceOne(20);
                      } else {
                        setPriceOne(event.target.value);
                      }
                    }}
                  />
                  <p className="placeholder">м2</p>
                </div>
              </div>
            );
          } else if (priceOne !== '' && (option.id === 2 || option.id === 3)) {
            return (
              <div className="sprzątanie-lokali" key={option.id}>
                <div
                  // onClick={() => setChangeUslugiFirstBlock(option.id === 2 ? 0 : 1)}
                  // onClick={event => setChangeUslugiFirstBlock(event.target.value = option.id === 2 ? 0 : 1)}
                  className={`sprzątanie-lokali__item${option.id === 3 ? ' sprzątanie-lokali__three' : (option.id === 2 ? ' sprzątanie-lokali__two' : '')}`}
                >
                  {option.id === 2 && (
                    // <label className='radio__label'>
                    //   <input className='radio__input' type="radio" checked={showFirst} onChange={toggleShowShowFirst} />
                    //   <h6>{option.name}</h6>
                    // </label>
                    <CustomRadio
                      id={option.id}
                      checked={showFirst}
                      onChange={toggleShowShowFirst}
                      name={option.name}
                    />
                  )}
                  {option.id === 3 && (
                    // <label className='radio__label'>
                    //   <input className='radio__input' type="radio" checked={showSecond} onChange={toggleShowShowSecond} />
                    //   <h6>{option.name}</h6>
                    // </label>
                    <CustomRadio
                      id={option.id}
                      checked={showSecond}
                      onChange={toggleShowShowSecond}
                      name={option.name}
                    />
                  )}
                </div>
              </div>
            );
          }
          return null;
        })}
        {priceOne !== '' && (

          <>
            {changeUslugiFirstBlock === 0 && (
              <ul className="first-block__list">
                <li>
                  <BlueMarker />
                  <span>Влажная и сухая протирка дверей;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Удаление пыли с открытых и легкодоступных поверхностей;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка фасадов шкафов и тумб высотой до 2 м;</span>
                </li>
                <li>
                  <WhiteMarker />
                  <span>Мойка фасадов и верха шкафов и тумб выше 2 м;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка мебели и бытовой техники снаружи;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Пылесосение и мытье полов без отодвигания мебели;</span>
                </li>
                <li>
                  <WhiteMarker />
                  <span>Пылесосение и мытье полов с отодвиганием мебели;</span>
                </li>
                <li>
                  <WhiteMarker />
                  <span>Удаление пыли с осветительных приборов и потолочных ламп;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка внутренних подоконников и радиаторов;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка зеркал;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Чистка раковины, умывальника, ванны, душевой кабины, унитаза, биде;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Удаление накипи с душевой кабины;</span>
                </li>
                <li>
                  <WhiteMarker />
                  <span>Мойка ванной плитки (без чистки швов);</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка и полировка сантехники;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка столешниц, плиты/индукционной панели, кухонной плитки;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Пылесосение мягкой мебели;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Пылесосение ковров и ковровых покрытий;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Загрузка грязной посуды в посудомоечную машину;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Опорожнение мусорного ведра;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Удаление паутины.</span>
                </li>
              </ul>
            )}
            {changeUslugiFirstBlock === 1 && (
              <ul className="first-block__list">
                <li>
                  <BlueMarker />
                  <span>Влажная и сухая протирка дверей;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Удаление пыли с открытых и легкодоступных поверхностей;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка фасадов шкафов и тумб высотой до 2 м;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка фасадов и верха шкафов и тумб выше 2 м;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка мебели и бытовой техники снаружи;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Пылесосение и мытье полов без отодвигания мебели;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Пылесосение и мытье полов с отодвиганием мебели;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Удаление пыли с осветительных приборов и потолочных ламп;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка внутренних подоконников и радиаторов;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка зеркал;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Чистка раковины, умывальника, ванны, душевой кабины, унитаза, биде;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Удаление накипи с душевой кабины;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка ванной плитки (без чистки швов);</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка и полировка сантехники;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Мойка столешниц, плиты/индукционной панели, кухонной плитки;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Пылесосение мягкой мебели;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Пылесосение ковров и ковровых покрытий;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Загрузка грязной посуды в посудомоечную машину;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Опорожнение мусорного ведра;</span>
                </li>
                <li>
                  <BlueMarker />
                  <span>Удаление паутины.</span>
                </li>
              </ul>
            )}
          </>
        )
        }
      </div>
    </div >
  )
}
